module.exports = __webpack_public_path__ + "ring.6c09eb16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/chatsuite/ring.png
// module id = 2077
// module chunks = 0